import { z } from 'zod';

import { DrawId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ReverseDrawEvent = BaseLoanEvent.extend({
  type: z.literal('reverseDraw'),
  drawId: DrawId,
  comment: z.string().optional(),
});
export type ReverseDrawEvent = z.infer<typeof ReverseDrawEvent>;
